// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../ContactBand";

export default function ServicesPage() {
  return (
    <main>
      <section className="page-hero ground list-hero" data-en="SERVICES">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <span>サービス</span>
          </nav>
          <h1 className="page-title center">
            サービス<strong>Services</strong>
          </h1>
          <p className="page-lead center">
            LEAPSは、AIとブロックチェーンを軸に、構想から開発、定着と成長までを一貫して手がけます。
          </p>
          <div className="hero-cta">
            <Link className="btn" to="/contact">
              <img src="/assets/icn_paperplane.svg" alt="" />
              無料相談
            </Link>
            <Link className="btn btn-sub" to="/cases">
              実績を見る
            </Link>
          </div>
        </div>
      </section>
      <section className="section svc-list-sec">
        <div className="container">
          <div className="svc-intro">
            <p className="svc-intro-lead">
              ソリューションとプロダクトで、
              <br />
              企業のデジタル変革を推進する。
            </p>
            <p className="svc-intro-text">
              お客様ごとの課題に向き合うソリューションと、そこで得た知見から生まれるプロダクト。
              <br className="pc" />
              この2つを循環させながら、AIやブロックチェーンを実際に使われる形にし、お客様のビジネスの未来を共に創造します。
            </p>
            <div className="duo">
              <div className="duo-stage">
                <div className="duo-circle duo-l">
                  <p className="duo-type">カスタマイズ型</p>
                  <h3>ソリューション</h3>
                  <p>
                    お客様ごとの課題に向き合い、
                    <br />
                    最適な仕組みを開発する。
                  </p>
                </div>
                <div className="duo-flow duo-f1">
                  <svg viewBox="0 0 160 40" aria-hidden="true">
                    <path
                      d="M8,36 Q80,-4 150,34"
                      fill="none"
                      stroke="#0b2140"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M141,26 L151,35 L138,38"
                      fill="none"
                      stroke="#0b2140"
                      strokeWidth="1.6"
                    />
                  </svg>
                  <span>
                    知見を抽象化し、
                    <br />
                    プロダクトへ
                  </span>
                </div>
                <div className="duo-flow duo-f2">
                  <svg viewBox="0 0 160 40" aria-hidden="true">
                    <path
                      d="M152,4 Q80,44 10,6"
                      fill="none"
                      stroke="#b38b4d"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M19,14 L9,5 L22,2"
                      fill="none"
                      stroke="#b38b4d"
                      strokeWidth="1.6"
                    />
                  </svg>
                  <span>
                    現場の声を、
                    <br />
                    ソリューションへ
                  </span>
                </div>
                <div className="duo-hub">
                  <img src="/assets/logo.svg" alt="LEAPS" />
                </div>
                <div className="duo-circle duo-r">
                  <p className="duo-type">パッケージ型</p>
                  <h3>プロダクト</h3>
                  <p>
                    開発の成果を汎用化し、
                    <br />
                    より多くの企業へ届ける。
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="svc-list-grid">
            <Link className="svc-list-card" to="/services/ai-integration">
              <div className="svc-list-img">
                <img
                  className="svc-main-img"
                  src="/assets/images/services/ai-integration-main-v5a.jpg"
                  alt="ビジネスパーソンの横顔に業務のデータやワークフローが重なるイメージ"
                />
              </div>
              <div className="svc-list-body">
                <span className="svc-label">Service 01</span>
                <h2>AIインテグレーション</h2>
                <p>
                  既存の業務にAIエージェントを組み込み、業務改革から、それを支える基盤づくりまでを開発します。
                </p>
                <span className="arrow-link">サービス詳細へ</span>
              </div>
            </Link>
            <Link className="svc-list-card" to="/services/blockchain">
              <div className="svc-list-img">
                <img
                  className="svc-main-img"
                  src="/assets/images/services/blockchain-main-photo.jpg"
                  alt="高層ビル群をネットワークの線がつなぐイメージ"
                />
              </div>
              <div className="svc-list-body">
                <span className="svc-label">Service 02</span>
                <h2>ブロックチェーン事業開発</h2>
                <p>
                  ブロックチェーン領域の豊富な知見をもとに、プロダクトの企画から設計・開発、リリース後の成長までを一貫して手がけます。
                </p>
                <span className="arrow-link">サービス詳細へ</span>
              </div>
            </Link>
          </div>
        </div>
      </section>
      <ContactBand />
    </main>
  );
}
